module.exports = __webpack_public_path__ + "static/media/PINK-BALL.cac9cc10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PINK-BALL.png
// module id = 264
// module chunks = 0